import { formatUIDate } from 'utils/helpers'
import { CollectorReportsReportPayloadItem } from '../interfaces'

export const toTableRowItems = (items: CollectorReportsReportPayloadItem[]) =>
  items.map(item => ({
    id: item.id,
    pvNumber: item.pvNumber ?? '',
    legalEntity: item.legalEntity ?? '',
    storeName: item.storeName ?? '',
    sapId: item.sapId ?? '',
    storeType: item.storeType ?? '',
    date: formatUIDate(item.date),
    categories: item.categories ?? '',
    carrierName: item.carrierName ?? '',
    regularizationCode: item.regularizationCode ?? '',
    companyName: item.destination ?? '',
    handedWeight: item.handedWeight ?? '',
    totalCalculatedWeight: item.totalCalculatedWeight ?? ''
  }))
